import { render, staticRenderFns } from "./TranscriptionDurationCard.vue?vue&type=template&id=2d3bfeef&scoped=true"
import script from "./TranscriptionDurationCard.vue?vue&type=script&lang=js"
export * from "./TranscriptionDurationCard.vue?vue&type=script&lang=js"
import style0 from "./TranscriptionDurationCard.vue?vue&type=style&index=0&id=2d3bfeef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3bfeef",
  null
  
)

export default component.exports